// @flow
import React, { Component } from 'react';
import { CommonActions } from 'store/actionCreators';
import type { State } from 'store';
import { connect } from 'react-redux';
import { type ContextRouter, type Location, withRouter } from 'react-router-dom';
import TagCurrent from 'components/tags/TagCurrent/TagCurrent';
import { type TagData } from 'store/modules/common';

type OwnProps = {
  tag: string,
  lastSort: string,
};

type Props = OwnProps & {
  selected: ?TagData,
} & ContextRouter;

class TagCurrentContainer extends Component<Props> {
  initialize = async () => {
    const { tag, history } = this.props;
    try {
      await CommonActions.getTagInfo(tag);
    } catch (e) {
      console.log(e);
      if (e && e.response && e.response.status === 404) {
        history.replace('/404');
      }
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.tag !== this.props.tag) {
      this.initialize();
    }
  }

  componentWillUnmount() {
    CommonActions.setTagInfo(null);
  }

  render() {
    const { tag, selected, lastSort } = this.props;
    return (
      <TagCurrent
        lastSort={lastSort}
        name={selected ? selected.name : tag}
        count={selected && selected.posts_count}
      />
    );
  }
}

export default connect(
  ({ common }: State) => ({
    selected: common.tags.selected,
    lastSort: common.tags.sort,
  }),
  () => ({}),
)(withRouter(TagCurrentContainer));



// WEBPACK FOOTER //
// ./src/containers/tags/TagCurrentContainer.js